export const DMS_MODULE = 'Administrace';
export const CRUMB_LABEL_EDIT = 'ServiceOrderHistory';
export const NAME = 'ServiceOrderHistory';
export const CRUMB_LABEL_KEY = 'ServiceOrderHistory';
export const PARTS_AND_LABOURS = 'PartsAndLabours';
export const EXPORT_FILE_NAME='CSHReport.xlsx';
export const DEPENDENT_TABLES = <const>[
	PARTS_AND_LABOURS
];
export type DependentTableNames = typeof DEPENDENT_TABLES[number];
export const PdiSelected ='0';
export const WithoutPdiSelected ='1';